import { render, staticRenderFns } from "./form-select-dynamic.vue?vue&type=template&id=5467d56b&"
import script from "./form-select-dynamic.vue?vue&type=script&lang=js&"
export * from "./form-select-dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports